import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/places.js';
import toolsMarkup from '../markup/tools.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const mainTabPane = document.querySelector('#places');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const body = document.querySelector('body');
const formAdd = body.querySelector('#locationCard');


const cardPlace = document.querySelector('#places_card');
const cardPlace_name = cardPlace.querySelector('#places_card-name');
const cardPlace_cX = cardPlace.querySelector('#places_card-cX');
const cardPlace_cY = cardPlace.querySelector('#places_card-xY');
const cardPlace_desc = cardPlace.querySelector('#places_card-desc');
const cardPlace_onMap = cardPlace.querySelector('#places_card-onMap');
const cardPlace_city = cardPlace.querySelector('#places_card_city_choose');
const cardPlace_SaveBT = cardPlace.querySelector('#places_card-Add-change');

const menuBt =  document.querySelector('#MenuLocations');
let currentArbitor; 
let currentPlaceID;
let placeID;

const onSuccessPointsLoad = (loadedPoints) => {
document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    console.log(loadedPoints);
    pointsMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);

  }
};

function clearCard() {
 cardPlace_name.value = '';
 cardPlace_cX.value = '';
 cardPlace_cY.value = '';
 cardPlace_desc.value = '';
 cardPlace_onMap.value = 0;
};

cardPlace_name.addEventListener('keyup', function(key) {
  validCardPlace();
});

function validCardPlace() {
  let validBool = true;
  if (cardPlace_name.value.length < 3) {
    cardPlace_name.classList.add('errorField');
    validBool = false;
  }


  if (cardPlace_cX.value.length >12) {
    cardPlace_cX.classList.add('errorField');
    validBool = false;
  }

  if (cardPlace_cY.value.length >12) {
    cardPlace_cY.classList.add('errorField');
    validBool = false;
  }

  cardPlace_SaveBT.disabled = !validBool;
};

cardPlace_SaveBT.addEventListener('click', function (evt) {
    let requestBody = 'name=' + cardPlace_name.value
                      + '&desc=' + cardPlace_desc.value
                      + '&latitude=' +  cardPlace_cX.value
                      + '&longitude=' + cardPlace_cY.value
                      + '&onMap=' + cardPlace_onMap.value;
    if(placeID == 0)
      xhr.request = {
        metod: 'POST',
        url: `places`,
        data: `${requestBody}`,
        callbackSuccess: onSuccessarPlaceRequest
      };
    else 
     xhr.request = {
      metod: 'PUT',
      url: `places/${placeID}`,
      data: `${requestBody}`,
      callbackSuccess: onSuccessarPlaceRequest
    };

});


const onSuccessarPlaceRequest = (loadedPoints) => {
  if (loadedPoints.status === 200) {
    $(cardPlace).modal('hide');
    getPlaces();
  }
};


mainTabPaneBody.addEventListener('click', function (evt) {
  evt.preventDefault();
  if(evt.target.attributes.action){
    let action = evt.target.attributes.action.nodeValue;
    if (action === 'delete') {
      if(parseInt( evt.target.attributes.countHalls.nodeValue, 10) > 1){
        alert('Удаление невозможно!\n\nК данной локации привязано более одного зала.\nСначала удалите их.');
      } else if (confirm('Вы уверены, что хотите удалить площадку?')) {
        xhr.request = {
          metod: 'DELETE',
          url: `places/${evt.target.attributes.pID.nodeValue}`,
          data: ``,
          callbackSuccess: getPlaces
        };
      }
    } else if (action === 'edit') {
      placeID = evt.target.attributes.pID.nodeValue;

      console.log(evt.target.attributes);
      cardPlace_name.value =  evt.target.attributes.pname.nodeValue;
      cardPlace_desc.value =  evt.target.attributes.padress.nodeValue;
      cardPlace_cX.value =  evt.target.attributes.plat.nodeValue;
      cardPlace_cY.value =  evt.target.attributes.plng.nodeValue;
      cardPlace_onMap.value =  evt.target.attributes.onmap.nodeValue;
      
      cardPlace_SaveBT.innerHTML = 'Сохранить';
      $(cardPlace).modal('show');
    } else if (action === 'newHall') {
      let newName = prompt('Укажите название нового зала:');
      if (newName)    
        xhr.request = {
          metod: 'POST',
          url: `places/${evt.target.attributes.pID.nodeValue}/hall`,
          data: `name=${newName}`,
          callbackSuccess: onSuccessarPlaceRequest
        };
    } else if (action === 'renameHall') {
       let newName = prompt('Укажите новое название:', evt.target.attributes.pName.nodeValue);
      if (newName && newName !== evt.target.attributes.pName.nodeValue)    
        xhr.request = {
          metod: 'PUT',
          url: `halls/${evt.target.attributes.hID.nodeValue}/`,
          data: `name=${newName}`,
          callbackSuccess: onSuccessarPlaceRequest
        };
    } else if (action === 'deleteHall') {
      if (confirm('Вы уверены, что хотите удалить зал?\n\nЕсли в расписании есть события с данным залом, то удаление не будет выполнено!')) 
        xhr.request = {
          metod: 'DELETE',
          url: `halls/${evt.target.attributes.hID.nodeValue}/`,
          data: ``,
          callbackSuccess: getPlaces
        };

    }
  };
});

function removeOptions(selectbox) {
  for (let i = selectbox.options.length - 1; i >= 0; i--) {
    selectbox.remove(i);
  }
}


mainTabPaneBTReload.addEventListener('click', function () {
  getPlaces();
});


mainTabPaneBTAdd.addEventListener('click', function () {
  clearCard();
  cardPlace_SaveBT.innerHTML = 'Добавить';
  placeID = 0;
  $(cardPlace).modal('show');
});

const getPlaces = () => {

  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: 'places',
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};

export default {

  start() {
    menuBt.addEventListener('click', getPlaces);
  },

  redraw: getPlaces,

  stop() {
    pointsMarkup.cleanContainer();
  }
};
